<template lang="html">
	<div class="map">
		<!-- {{data}} -->
		<map></map>
	</div>
</template>

<script>
const gmaps = require('google-maps');
gmaps.KEY = window.YAMASTERS_FRONTEND.googleMaps.publicKey;
// console.log(gmaps);

module.exports = {
	name: 'bottom-map',
	
	props: ['data'],
	
	computed: {
		coords() {
			return this.data ? this.data.coords : [];
		},
		
		image() {
			return this.data ? this.data.imagePath : '';
		}
	},
	
	data() {
		return {
			initialized: false
		}
	},
	
	methods: {
		init() {
			if(!this.initialized) {
				
				gmaps.load(google => {
					var directionsService = new google.maps.DirectionsService;
					var directionsDisplay = new google.maps.DirectionsRenderer({
						markerOptions: {
							clickable: false,
							// visible: false
						}
					});
					
					var map = new google.maps.Map(document.querySelector('.GoogleMap.bottom-map map'), {
						zoom: 7,
						center: {lat: 50.451193, lng: 30.474092},
						disableDefaultUI: true,
						scrollwheel: false,
						styles: [
							{
								"featureType": "administrative.land_parcel",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "poi",
								"stylers": [
									{
										"saturation": -100
									}
								]
							},
							{
								"featureType": "poi.attraction",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "poi.business",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "poi.place_of_worship",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							}
						]
					});
					
					let walk = new google.maps.Polyline({
						path: [
							this.coords[1],
							{
								lat: 50.451183,
								lng: 30.474088
							}
						],
						geodesic: true,
						strokeColor: '#6AB0F6',
						strokeOpacity: 1.0,
						strokeWeight: 5
					});
					
					var marker = new google.maps.Marker({
						position: {
							lat: 50.451009,
							lng: 30.473756
						},
						icon: `${this.image}yamasters.jpg`,
						map: map,
						title: 'Я-Masters',
						clickable: false
					});
					
					directionsDisplay.setMap(map);
					
					walk.setMap(map);
					
					const calculateAndDisplayRoute = (directionsService, directionsDisplay) => {
						directionsService.route({
							// origin: 'Київ, метро КПІ',
							origin: this.coords[0],
							destination: this.coords[1],
							travelMode: 'WALKING'
						}, function(response, status) {
							if (status === 'OK') {
								directionsDisplay.setDirections(response);
							} else {
								window.alert('Directions request failed due to ' + status);
							}
						});
					}
					
					calculateAndDisplayRoute(directionsService, directionsDisplay);
				})
				
				this.initialized = true;
			}
		}
	}
}
</script>

<style lang="scss">
@import "scss/wanted";
.GoogleMap.bottom-map {
	map {
		display: block;
		height: 300px;
		background: url('#{$imgPathSCSS}gps.svg') no-repeat center;
		
		@include m_up {
			height: rem(400);
		};
		
		@include l___up {
			height: rem(500)
		};
	}
}
</style>



// WEBPACK FOOTER //
// bottom.vue?aab8a632